<template>
  <div>
    <v-container id="classCreate">
      <v-card max-width="800px">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-form ref="integrationForm" v-model="valid">
            <v-text-field
              v-model="integration.name"
              :label="$t('integrations.edit.fields.name.title')"
              :required="required"
              :rules="[rules.required]"
              compact
              :hint="$t('integrations.edit.fields.name.hint')"
            />
            <v-text-field
              v-model="integration.redirectUrl"
              :label="$t('integrations.edit.fields.redirectUrl.title')"
              :required="required"
              :rules="[rules.required]"
              compact
              :hint="$t('integrations.edit.fields.redirectUrl.hint')"
            />
            <v-text-field
              v-model="integrationLti.consumerUrl"
              label="LMS URL"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
            <v-text-field
              v-model="integrationLti.consumerName"
              label="Name"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
            <v-text-field
              v-model="integrationLti.consumerToolClientID"
              label="Client ID"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
            <v-text-field
              v-model="integrationLti.consumerAuthorizationURL"
              label="Auth URL"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
            <v-text-field
              v-model="integrationLti.consumerAccessTokenURL"
              label="Token URL"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
            <v-text-field
              v-model="consumerAuthorizationconfig.key"
              label="Cert URL"
              :required="required"
              :rules="[rules.required]"
              compact
              hint=""
            />
          </v-form>
        </v-card-text>
        <v-card-text>
          <div v-if="!valid">
            <span class="validateError">{{ $t('integrationEdit.validate-info') }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" @click="cancel">
            {{ $t('global.cancel') }}
          </v-btn>
          <v-btn :disabled="!valid" color="success" @click="validate">
            {{ $t('global.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'EditIntegration',
    props: {
      model: {
        type: Object,
        required: true,
        default: undefined,
      },
      editors: {
        type: Array,
        required: false,
        default: undefined,
      },
      classes: {
        type: Array,
        required: false,
        default: undefined,
      },
    },

    data () {
      return {
        title: this.$t('integrations.edit.title.create'),
        rules: {
          required: value => {
            return !!value || this.$t('integrationEdit.required')
          },
        },
        integration: {
          name: '',
          redirectUrl: '',
        },
        integrationLti: {
          consumerUrl: '',
          consumerName: '',
          consumerToolClientID: '',
          consumerAuthorizationURL: '',
          consumerAccessTokenURL: '',
          consumerRedirect_URI: '',
        },
        kid: {
          publicKey: '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqAjoDVoGM6oPDSN6OAkf\nYbwB83CUfqA8Z1tg+Z1nmLyEnqNsq4Ok+7zLBav3oiS3kX6BjwQZtOo7scgmpGz/\nMKLRgFcudNTQKxNRnYSqs1Yfro9p3t5eMZOJ8w31q0yXGEg75GYlBOGxoR60zeGj\n9QZqILnimlRmW75DyBIVOeQsHadUJ1SjZxMjIyDMh43VdlfX9Z5O265zvQHdI2HV\nNqHEKbnwP8EsKxpDdJ2PWV6XAGKCwTx4iisZY5UA1xoix45RhFkoVw3bP68HpWGt\nT27x7+lu/1BIawv854/3cxMMv1HnthaetN+rmLLO7kjJO6D4S9kzSsTp4+RFmftc\nRQIDAQAB\n-----END PUBLIC KEY-----',
          privateKey: 'set-by-server',
          keyID: '9xB6odLoeBLxnEa1HIqX9yep1MC9dHCFQOthncqpVNjsh0fREsnbvw2WsBut0WlAJ6FkO15xYv4w5nbpsMDMlcOE6QMWiHjvsZ5wgs5qM2dLgQ8h6uM8IM3iGSw3h9ixuVaDRYaZrjiKh2FuS2GeaCO7ClRTYEEGnIJY297VdqXir0FlaJ7paL3HwXkuMJo2oZIjZnEpApFYv5CWEkiZbfr0PKbsYR5VIxaGD9AzvsTfxV7AwyZWt8jhArKw2kA',
        },

        consumerAuthorizationconfig: {
          method: 'JWT_SET',
          key: '',
        },
        valid: false,
        required: false,
      }
    },

    mounted () {
      if (this.model.id) {
        this.integration = { ...this.model }
        this.integrationLti = { ...this.model.lti }
        this.consumerAuthorizationconfig = { ...this.model.lti.consumerAuthorizationconfig }
      }
      this.valid = true
    },

    methods: {
      cancel () {
        this.$emit('cancel')
      },
      validate () {
        const emitData = {
          ...this.integration,
          lti: {
            ...this.integrationLti,
            kid: this.kid,
            consumerAuthorizationconfig: this.consumerAuthorizationconfig,
          },
        }
        this.reset()
        this.$emit('save', emitData)
      },
      reset () {
        this.integration.name = ''
        this.integration.redirectUrl = ''
        this.integrationLti.consumerUrl = ''
        this.integrationLti.consumerName = ''
        this.integrationLti.consumerToolClientID = ''
        this.integrationLti.consumerAuthorizationURL = ''
        this.integrationLti.consumerAccessTokenURL = ''
        this.integrationLti.consumerRedirect_URI = ''

        this.valid = true
      },
    },
  }
</script>

<style>
.warningtext {
  color: red !important;
  font-size: 11px;
  font-weight: bold;
  background: none;
}

.chip-class {
  text-transform: lowercase !important;
}

.validateError {
  color: red;
  font-size: 1em;
  background: none;
}

.invisible {
  opacity: 0;
}
</style>

